// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".connect-lines-answer[data-v-13212394]{display:flex;flex-direction:row;align-items:flex-start}.answers-list[data-v-13212394]{list-style:disc}.marked-element[data-v-13212394]{margin-left:30px}", ""]);
// Exports
module.exports = exports;
